import React, { Component } from "react";
import mapboxgl from "mapbox-gl";
import { drawRoute } from "./drawRoute";
import { getRoute } from "../../utils/api";
import SearchBox from "./SearchBox";
import { AppHeader } from "../../components/AppHeader";
import { MapContainer } from "./MapContainer";
import "mapbox-gl/dist/mapbox-gl.css";

class Map extends Component {
  map = null;
  mapContainer = React.createRef();

  componentDidMount() {
    mapboxgl.accessToken =
      "pk.eyJ1Ijoic2F0YW5zZGVlciIsImEiOiJja2hrcmp6ZWEwOWZxMnNsbjc1NXlrcTd5In0.w964wIfUKgnYjQLp0Ods7Q";
    this.map = new mapboxgl.Map({
      container: this.mapContainer.current,
      style: "mapbox://styles/mapbox/light-v10",
      center: [30.2656504, 59.8029126],
      zoom: 15
    });
  }

  order = (address1, address2) => {
    drawRoute(this.map, getRoute(address1, address2));
  };

  reset = () => {
    this.map.removeLayer("route");
    this.map.removeSource("route");
  };

  componentWillUnmount() {
    this.map.remove();
  }

  render() {
    return (
      <>
        <AppHeader />
        <MapContainer ref={this.mapContainer}>
          <SearchBox order={this.order} reset={this.reset} />
        </MapContainer>
      </>
    );
  }
}

export default Map;
